<template>
  <div>
    <template v-if="isEditingFormula">
      <sInput
        ref="formulaInput"
        :class="[!!formulaError || error ? 'formula-input-error' : '']"
        clearable
        :value.sync="internalFormula"
        @blur="onFormulaBlur"/>
    </template>
    <div
      v-else
      class="s-input text-left"
      :class="{'formula-input-error': !!formulaError || error }"
      @click="onFormulaFocus">
      <div
        class="s-input__inner flex flex-between"
        style="padding-right: 5px !important;">
        <ShowFormula
          v-if="formula"
          class="my-auto"
          :formula-string="highlightedFormula"
          style="line-height: 1; overflow: hidden; white-space: nowrap;"
          text/>
        <sButton
          class="my-auto ml-auto"
          icon="cross"
          small
          type="text"
          @click="internalFormula = ''"/>
      </div>
    </div>
    <div
      v-if="formulaError"
      class="text-left sFormItem__error">
      {{ formulaError }}
    </div>
  </div>
</template>

<script>
import calculateFormula from '@/utils/calculateFormula.js'
import ShowFormula from 'components/common/ShowFormula.vue'

import godModeMixin from 'mixins/godModeMixin'

export default {
  name: 'AddMathFormula',
  mixins: [godModeMixin],
  props: {
    formula: String,
    error: [Boolean, String],
    max_length: [String, Number],
    variables: Array,
  },
  data() {
    return {
      internalFormula: this.formula,
      formulaError: null,
      highlightedFormula: '',
      isEditingFormula: false,
      formulaInputRef: null,
      errors: {
        'unknownError': 'Невідома помилка',
        'undefinedVariables': 'Не визначені змінні:',
        'undefinedVariable': 'Не визначена змінна:',
        'undefinedFunctions': 'Не визначені функції:',
        'divisionByZero': 'Ділення на нуль',
        'errorLastSymbol': 'Недопустимий оcтанній символ',
        'Digit expected, got': 'Очікується цифра.',
        'Syntax error in part': 'Синтаксична помилка в частині виразу.',
        'Unexpected part': 'Неочікувана частина виразу.',
        'Invalid left hand side of assignment operator =': 'Неправильна ліва частина оператора присвоєння =.',
        'False part of conditional expression expected': 'Очікується хибна частина умовного виразу.',
        'Parenthesis ) expected': 'Не співпадає баланс ().',
        'Parenthesis ] expected': 'Не співпадає баланс [].',
        'Property name expected after dot': 'Очікується ім’я властивості після крапки.',
        'Invalid unicode character': 'Неправильний символ Unicode.',
        'Bad escape character': 'Неправильний символ екранування.',
        'End of string': 'Кінець рядка.',
        'End of matrix ] expected': 'Очікується кінець матриці ].',
        'Symbol or string expected as object key': 'Очікується символ або рядок як ключ об’єкта.',
        'Colon : expected after object key': 'Очікується двокрапка : після ключа об’єкта.',
        'Comma , or bracket } expected after object value': 'Очікується кома , або дужка } після значення об’єкта.',
        'Unexpected end of expression': 'Неочікуваний кінець виразу.',
        'Value expected': 'Помилка в символі',
        'Unexpected operator': 'Неочікуваний оператор.',
        'Column dimensions mismatch': 'Невідповідність розмірів стовпців.',
      }
    }
  },
  watch: {
    formula: {
      immediate: true,
      handler(newVal) {
        this.internalFormula = newVal
        this.calculateFormula()
      }
    },
    internalFormula: {
      handler(newVal) {
        this.$emit('update:formula', newVal)
        this.calculateFormula()
      }
    },
    variables: {
      deep: true,
      handler() {
        this.calculateFormula()
      }
    }
  },
  methods: {
    onFormulaFocus() {
      this.isEditingFormula = true
      this.$nextTick(() => {
        if (this.$refs.formulaInput) {
          this.$refs.formulaInput.focus()
        }
      })
    },
    onFormulaBlur() {
      this.isEditingFormula = false
    },
    calculateFormula() {
      const { result, error, highlightedFormula } = calculateFormula(this.internalFormula, this.variables)
      const errorResult = error && typeof error === 'object' ? error : { key: null, label: '' }
      if (error && !this.mixin_isGodMode) {
        let label = this.errors[error.key] || error.label || this.errors['unknownError']
        if (error.props?.length) {
          label = (this.errors[error.key] || this.errors['unknownError']) + ' ' + error.props.join(', ')
        }
        errorResult.label = this.formulaError = label
        errorResult.highlightedFormula = this.highlightedFormula = highlightedFormula
        this.$emit('update:error', errorResult)
      } else {
        if (error && this.mixin_isGodMode) {
          this.$sinfo('Formula calculation error (God Mode):', error)
        }

        this.formulaError = null
        errorResult.highlightedFormula = this.highlightedFormula = this.internalFormula
        this.$emit('update:error', errorResult)
        this.$emit('result', result)
      }
    },
  },
  components: {
    ShowFormula
  }
}
</script>
